import { messagingSupportedPromise } from 'api/Firebase/firebase-messaging'
import { useEffect, useState } from 'react'
import { useAlert } from 'store/useAlert'
import { useMessagingToken } from 'store/useMessagingToken'
import { useWizardForm } from 'store/useWizardForm'
import { PushNotificationModal } from './PushNotificationModal'

interface PushNotificationProps {
  show: boolean
  onClose: () => void
}

export const PushNotification = ({ show, onClose }: PushNotificationProps) => {
  const { addAlert } = useAlert()
  const { setPushToken, updateWizardForm } = useWizardForm()
  const { ensureToken: refreshToken } = useMessagingToken()
  const [status, setStatus] = useState<'pending' | 'granted' | 'denied' | 'loading'>('loading')

  const getToken = async () => {
    setStatus('loading')
    try {
      const token = await refreshToken()
      setStatus('granted')
      setPushToken(token)
    } catch (e) {
      if (e instanceof Error) {
        addAlert(e.message, 'error')
      } else {
        addAlert('Unknown error', 'error')
      }
      setPushToken(undefined)
      setStatus('denied')
    }
  }

  const getNotificationPermission = async () => {
    try {
      const permission = await Notification.requestPermission()
      if (permission === 'granted') {
        await getToken()
      } else {
        setStatus('denied')
        setPushToken(undefined)
      }
    } catch (e) {
      if (e instanceof Error) {
        addAlert(e.message, 'error')
      } else {
        addAlert('Unknown error', 'error')
      }
      console.error(e)
    }
  }

  useEffect(() => {
    messagingSupportedPromise.then(supported => {
      if (!supported || !('Notification' in window)) {
        setPushToken(undefined)
        setStatus('denied')
        return
      }
      if (Notification.permission === 'granted') {
        void getToken()
        return
      }
      if (Notification.permission === 'denied') {
        setStatus('denied')
        return
      }
      setStatus('pending')
    })
  }, [])

  useEffect(() => {
    if (show) {
      setTimeout(getNotificationPermission, 2000)
    }
  }, [show])

  useEffect(() => {
    updateWizardForm({ notificationStatus: status })
  }, [status])

  return <PushNotificationModal show={show} status={status} onClose={onClose} />
}
